import React from "react";
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { SIGNUP_MODAL_FLAG } from '../../utils/actions';

import Button from "react-bootstrap/Button";

import './Footer.css';

function Footer() {
  const dispatch = useDispatch();

  function showSignup() {
    dispatch({ type: SIGNUP_MODAL_FLAG, show: true });
  }

  return (
    <footer>

      <nav>
        <div>
          <div>
            {/*<h3>Information</h3>*/}
            <ul>
              <li><Link to="/privacy">Privacy and Cookie Policy</Link></li>
            </ul>
{ /*
Search Terms
Advanced Search
Orders and Returns
Contact Us*/ }
          </div>

          <div>

            {/*<h3>Contact</h3>*/}
            <ul>
              <li>Email <a href="mailto:sales@oshikem.com">sales@oshikem.com</a></li>
            </ul>


          </div>

          <div>
            <ul>
              <li>Get latest deals and discount codes:</li>

            <Button variant="outline-primary" size="sm" onClick={showSignup}>
              Add your email to our mailing list
            </Button>
            <p>(We will never share your email with anyone else.)</p>
            </ul>
          </div>

        </div>

      </nav>

      <p>
        This site may use affiliate links. When you shop affiliate links, we receive a commission on qualifying purchases at no additional cost to you. • Copyright © 2026 Oshikem - Premium Deals. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
